// extracted by mini-css-extract-plugin
module.exports = {"shadow":"ConfirmResign_shadow__q1qf_","wrapper":"ConfirmResign_wrapper__RZHll"};